import socket from './socket';

const getOrCreateDampingCoefficient = (pointSystemId, headers) =>
  socket.post(`/point-systems/${pointSystemId}/damping-coefficients/get-or-create`, undefined, headers);

const fetchDampingCoefficients = (pointSystemId, headers) =>
  socket.get(`/point-systems/${pointSystemId}/damping-coefficients`, undefined, headers);

const createDampingCoefficient = (pointSystemId, data, headers) =>
  socket.post(`/point-systems/${pointSystemId}/damping-coefficients`, data, headers);

const updateDampingCoefficient = (id, data, headers) =>
  socket.patch(`/damping-coefficients/${id}`, data, headers);

const deleteDampingCoefficient = (id, headers) =>
  socket.delete(`/damping-coefficients/${id}`, undefined, headers);

export default {
  getOrCreateDampingCoefficient,
  fetchDampingCoefficients,
  createDampingCoefficient,
  updateDampingCoefficient,
  deleteDampingCoefficient,
};

